export default __webpack_public_path__ + "static/media/wallet-product-freezer.5b5abeb1.svg";